import { keyframes, styled } from "styled-components";

import { Spacer, Text } from "@vericus/cadmus-ui";

import Sprite from "@/assets/loading-sprite.png";

const sprite = keyframes`
  from {
    background-position: 0px;
  }
  to {
    background-position: -5400px;
  }
`;

const Quill = styled.div`
  width: 180px;
  height: 81px;
  overflow: hidden;
  background-image: url(${Sprite});
  animation: ${sprite} 0.5s steps(30) infinite alternate;
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: fixed;
  width: 100vw;
  height: 100vh;
  z-index: 1000;
  top: 0;
`;

const LoadingText = styled(Text)`
  text-transform: uppercase;
  font-weight: 600;
`;

/**
 * A full page loading indicator. Uses a CSS animated spritesheet.
 */
export const Loading = ({ message }: { message?: string }) => (
  <Container>
    <Quill />
    <Spacer spacing={27} />
    {message ? (
      <LoadingText kind="systemMd" color="shade1" as="div">
        {message}
      </LoadingText>
    ) : null}
  </Container>
);
